import { createServerFn } from "@tanstack/react-start";

export type CategoryProductCounts = Record<string, number>;

export const categoryCountsQueryOptions = () => ({
  queryKey: ["category-product-counts"] as const,
  queryFn: () => getCategoryProductCounts(),
  staleTime: 5 * 60 * 1000,
});

export const getCategoryProductCounts = createServerFn({ method: "GET" }).handler(
  async (): Promise<CategoryProductCounts> => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");

    const [{ data: links }, { data: products }, { data: categories }] = await Promise.all([
      supabaseAdmin.from("product_categories").select("category_id, product_id"),
      supabaseAdmin.from("products").select("id, status").eq("status", "publish"),
      supabaseAdmin.from("categories").select("id, slug"),
    ]);

    const publishedIds = new Set((products ?? []).map((p) => (p as { id: string }).id));
    const countByCategoryId = new Map<string, number>();

    for (const row of links ?? []) {
      const productId = (row as { product_id?: string }).product_id;
      const categoryId = (row as { category_id?: string }).category_id;
      if (!productId || !categoryId || !publishedIds.has(productId)) continue;
      countByCategoryId.set(categoryId, (countByCategoryId.get(categoryId) ?? 0) + 1);
    }

    const result: CategoryProductCounts = {};
    for (const cat of categories ?? []) {
      const slug = (cat as { slug?: string }).slug;
      const id = (cat as { id?: string }).id;
      if (!slug || !id) continue;
      result[slug] = countByCategoryId.get(id) ?? 0;
    }

    return result;
  }
);
